import { Colors } from "components/colors";
import { Font } from "components/font";
import { spacing } from "libs/styles/variables";
import { ComponentProps, forwardRef, memo, ReactNode } from "react";
import styled from "styled-components";
import { CheckBox } from ".";

type Props = {
  children: ReactNode;
  block?: boolean;
  labelClassName?: string;
} & ComponentProps<typeof CheckBox>;

export const CheckBoxLabel = memo(
  forwardRef<HTMLInputElement, Props>(
    (
      { children, block = false, className, disabled = false, labelClassName, ...otherProps },
      ref,
    ) => {
      return (
        <Base $block={block} $disabled={disabled} className={className}>
          <CheckBox {...otherProps} disabled={disabled} ref={ref} />
          <span className={labelClassName}>{children}</span>
        </Base>
      );
    },
  ),
);
CheckBoxLabel.displayName = "CheckBoxLabel";

const Base = styled.label<{ $block: boolean; $disabled: boolean }>`
  align-items: center;
  color: ${Colors.black56};
  cursor: ${({ $disabled }) => ($disabled ? "default" : "pointer")};
  display: inline-flex;
  font-size: ${Font.fontSizeXs};
  padding-right: ${spacing.xs};
  ${({ $block }) => $block && "display: block; width: 100%;"};

  span {
    margin-left: ${spacing.sm};
  }
`;
